import * as React from "react";
import {connect} from "react-redux";
import ActivityFeedComponent from "../components/ActivityFeedComponent";
import {feedsMetaSelector, feedsSelector, loadingFeedsSelector} from "../selectors";
import Meta from "../../_data/models/Meta";
import {fetchFeeds} from "../middlewares";
import {Iterable} from "immutable";
import {RouteComponentProps} from "react-router";
import {currentUserIdSelector} from "../../user/selectors";
import isOrdered = Iterable.isOrdered;

interface Props extends RouteComponentProps<any> {
    openModal: boolean;
    selectedFeedId: number;
}

const mapStateToProps = (state, props: Props) => {
    const {openModal, selectedFeedId} = props;

    return {
        feeds: feedsSelector(state).sortBy(f => f.id).reverse(),
        meta: feedsMetaSelector(state),
        loading: loadingFeedsSelector(state),
        openModal: openModal,
        selectedFeedId: selectedFeedId,
        currentUserID: currentUserIdSelector(state)
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadMore: (meta: Meta) => {
            if (meta && meta.hasNext()) {
                dispatch(fetchFeeds(meta.cursor, meta.nextPage));
            }
        }
    }
};

const ActivityFeedContainer = connect<any, any, Props>(mapStateToProps, mapDispatchToProps)(ActivityFeedComponent);
export default ActivityFeedContainer;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/containers/ActivityFeedContainer.tsx